import React from 'react';
import Classes from '../Dashboard.module.css';
import Switch from '@mui/material/Switch';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';

const label = { inputProps: { 'aria-label': 'Switch demo' } };

const CustomSwitch = styled(Switch)(({ theme }) => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: '#006B32',
    '&:hover': {
      backgroundColor: 'rgba(255, 87, 34, 0.08)',
    },
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: '#006B32',
  },
}));

const ClientsIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 576 512">
    <path d="M264.5 5.2c14.9-6.9 32.1-6.9 47 0l218.6 101c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 149.8C37.4 145.8 32 137.3 32 128s5.4-17.9 13.9-21.8L264.5 5.2zM476.9 209.6l53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 277.8C37.4 273.8 32 265.3 32 256s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0l152-70.2zm-152 198.2l152-70.2 53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 405.8C37.4 401.8 32 393.3 32 384s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0z" />
  </svg>
);

const DeletedIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 640 512">
    <path d="M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3zM471 143c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z" />
  </svg>
);

const ExposuresIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 512 512">
    <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352c79.5 0 144-64.5 144-144s-64.5-144-144-144S64 128.5 64 208s64.5 144 144 144z" />
  </svg>
);

const FileIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 384 512">
    <path d="M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM80 64l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 96l192 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32L96 352c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zm0 32l0 64 192 0 0-64L96 256zM240 416l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z" />
  </svg>
);

const InProgressIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 512 512">
    <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 344l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24z" />
  </svg>
);

export default function Hero1({ reports }) {
  // Calculate metrics
  const totalExposures = reports?.reduce((sum, report) => sum + (report.exposures?.length || 0), 0) || 0;
  const deletedRecords = reports?.reduce(
    (sum, report) =>
      sum + (report.exposures?.filter((e) => e.deletionStatus === 'completed')?.length || 0),
    0
  ) || 0;
  const inProgressReports = reports?.filter((report) => report.analyzingstatus === 'inProgress').length || 0;

  // Calculate the most recent report date
  const lastReportDate = reports?.length > 0
    ? new Date(Math.max(...reports.map((r) => new Date(r.createdAt))))
    : null;
  const daysAgo = lastReportDate
    ? Math.floor((new Date() - lastReportDate) / (1000 * 60 * 60 * 24))
    : null;

    const navigateTo = useNavigate();
  const handleViewReport = () => {
    // Scroll to Reports section
    navigateTo('/reports');
  };

  return (
    <div className={Classes.hero1}>
      {/* <div className={Classes.heroBox}>
        <div className={Classes.hero1Img}>
          <InProgressIcon height="27px" width="27px" fill="white" />
        </div>
        <div>
          <h5 className={Classes.title1}>In Progress Reports</h5>
          <h3>{inProgressReports}</h3>
        </div>
      </div> */}

      {/* <div className={Classes.miniLine}></div> */}

      <div className={Classes.heroBox}>
        <div className={Classes.hero1Img}>
          <ClientsIcon height="27px" width="27px" fill="white" />
        </div>
        <div>
          <h5 className={Classes.title1}>Data Records Reviewed</h5>
          <h3>{totalExposures}</h3>
        </div>
      </div>

      <div className={Classes.miniLine}></div>

      <div className={Classes.heroBox}>
        <div className={Classes.hero1Img}>
          <DeletedIcon height="27px" width="27px" fill="white" />
        </div>
        <div>
          <h5 className={Classes.title1}>Data Records Deleted</h5>
          <h3>{deletedRecords}</h3>
        </div>
      </div>

      <div className={Classes.miniLine}></div>

      <div className={Classes.heroBox}>
        <div className={Classes.hero1Img}>
          <ExposuresIcon height="27px" width="27px" fill="white" />
        </div>
        <div>
          <h5 className={Classes.title1}>Total Exposures</h5>
          <h3>{totalExposures}</h3>
        </div>
      </div>

      <div className={Classes.miniLine}></div>

      <div className={Classes.heroBox}>
        <div className={Classes.hero1Img}>
          <FileIcon height="27px" width="27px" fill="white" />
        </div>
        <div>
          <h5 className={Classes.title1}>Last Report</h5>
          <div className={Classes.flexAlign5}>
            <h3>{daysAgo !== null ? `${daysAgo}D Ago` : 'N/A'}</h3>
            <h5 className={Classes.viewText} onClick={handleViewReport} style={{ cursor: 'pointer' }}>
              View
            </h5>
          </div>
        </div>
      </div>
    </div>
  );
}